module.exports = __webpack_public_path__ + "img/Junk Removal.ae638520.svg";